// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IUNB","content":"Ui1yE"};